module.exports = __webpack_public_path__ + "img/list_page_first.e3dc72ac.png";